<template>
  <div>
      <div>
        <div class="vx-row">
          <div class="vx-col w-1/2">
            <span>Seleccione la región</span>
            <ul class="flex mt-2" style="flex-wrap: wrap;">
              <li class="mr-3">
                <vs-radio v-model="tipoRegion" @input="arrayPeriodos=[];periodoSelected='';obtenerPeriodos();" vs-name="radios1tipoFiltro" vs-value="1">Sierra</vs-radio>
              </li>
              <li class="mr-3">
                <vs-radio v-model="tipoRegion" @input="arrayPeriodos=[];periodoSelected='';obtenerPeriodos();" vs-name="radios1tipoFiltro" vs-value="2">Costa</vs-radio>
              </li>
            </ul>
          </div>
          <div class="vx-col w-1/2">
            <span>Seleccione el período</span>
            <div class="flex">
              <v-select
                :options="arrayPeriodos"
                :reduce="periodo => periodo.idperiodoescolar"
                label="periodoescolar"
                class="w-full mt-2"
                v-model="periodoSelected"
                @input="filtrarReporte()"
              />
            </div>
          </div>
        </div>
        <div class="vx-row mt-5">
          <div class="vx-col w-1/2">
            <span>Seleccione la serie</span>
              <div class="flex">
                <v-select
                  :options="arraySerie"
                  :reduce="serie => serie.id_serie"
                  label="nombre_serie"
                  class="w-full mt-2"
                  v-model="serieSelected"
                  @input="filtrarReporte()"
                />

              </div>
          </div>
          <div class="vx-col w-1/2">
             <!--boton para filtrar-->
             <vs-button color="primary" @click="filtrarReporte()" class="ml-2 mb-2" style="margin-top:30px;" type="filled">
              Filtrar
            </vs-button>
          </div>
        </div>
        <br>
        <div v-if="arrayReporte.length > 0">
          <div class="flex">
            <div class="w-1/2">
              <p class="text-center font-bold"> Total de códigos: {{ totalLibros }} </p>
            </div>
            <div class="w-1/2">
              <p class="text-center font-bold"> Periodo: {{ arrayPeriodos.find(x => x.idperiodoescolar == periodoSelected).periodoescolar }} </p>
            </div>
          </div>
          <TableReutilizableVue
            :title="'Reporte por serie'"
            :ifexportar="Number(1)"
            :nombrearchivo="'Reporte_'+arrayPeriodos.find(x => x.idperiodoescolar == periodoSelected).periodoescolar+'-Serie_'+arraySerie.find(x => x.id_serie == serieSelected).nombre_serie"
            :headers="['codigo','Libro','Cantidad']"
            :fieldKeys="['codigo','nombrelibro','cantidad']"
            :tableData="arrayReporte"
          />
        </div>
        <div v-else>
          <p class="text-center font-bold"> No hay códigos para el período seleccionado </p>
        </div>
      </div>
  </div>
</template>
<script>
import vSelect from 'vue-select'
import PeriodoRepository from '@/repositories/PeriodoRepository';
const TableReutilizableVue              = () => import('@/views/pedidos2/pedidos/reportes/components/TableReutilizable.vue')
import Generalmix from '../../../mixins/Generalmix';
export default {
  mixins: [Generalmix],
  components: {
    'v-select': vSelect,
    TableReutilizableVue,
  },
  data() {
    return{
      arrayPeriodos:[],
      periodoSelected: '',
      tipoRegion: '1',
      arrayReporte:[],
      arraySerie:[],
      serieSelected:'',
      totalLibros:0,
    }
  },
  mounted() {
    this.f_obtenerSeries();
    this.obtenerPeriodos();
  },
  methods:{
    f_obtenerSeries(){
      let me = this;
      var url = `series`
      this.$http.get(this.$server_url+url)
      .then(function (res) {
        me.arraySerie = res.data;
      })
      .catch(function (error) {
        console.log(error + ' error');
      })
    },
    obtenerPeriodos() {
      this.$vs.loading();
      PeriodoRepository.getPeriodos()
      .then(p => {
          this.arrayPeriodos = p.data
          this.filtrarPeriodos(p.data);
          this.$vs.loading.close();
      })
      .catch(error => {
          this.m_message("Error al cargar los períodos", "error");
          console.error(error);
          this.$vs.loading.close();
      });
    },
    filtrarPeriodos(datos) {
      this.arrayPeriodos = datos.filter(p => p.region_idregion == this.tipoRegion);
    },
    filtrarReporte(){
      let me = this;
      me.arrayReporte = [];
      me.totalLibros  = 0;
      if(me.serieSelected == '' || me.serieSelected == null || me.serieSelected == undefined){
        me.m_message('Debe seleccionar una serie','danger')
        return false;
      }
      if(me.periodoSelected == '' || me.periodoSelected == null || me.periodoSelected == undefined){
        me.m_message('Debe seleccionar un periodo','danger')
        return false;
      }
      me.$vs.loading();
      var url = `metodosGetCodigos?reporteBodega_new=1&periodo=${me.periodoSelected}&serie=${me.serieSelected}`
      this.$http.get(this.$server_url+url)
      .then(function (res) {
         me.arrayReporte = res.data;
         me.$vs.loading.close();
         if(me.arrayReporte.length == 0){
            me.$vs.notify({
              text:'No hay códigos para el período seleccionado',
              color:'warning',
              iconPack: 'feather',
              icon:'icon-alert-triangle'
            })
            return false;
         }
         //sumar cantidad de libros
         me.arrayReporte.forEach(p => {
           me.totalLibros += p.cantidad
         })
      })
      .catch(function (error) {
        me.$vs.loading.close();
          console.log(error + ' error');
        me.$vs.notify({
          text: 'Ocurrio un error al filtrar los reportes',
          color: 'danger',
          iconPack: 'feather',
          icon: 'icon-alert-triangle'
        })
      })
    },
  }
}
</script>
